import { Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { VerifyEmailPage } from './pages/VerifyEmailPage';
import { DashboardPage } from './pages/DashboardPage';
import { UsersPage } from './pages/UsersPage';
import { ProfilePage } from './pages/ProfilePage';
import { SquadsPage } from './pages/SquadsPage';
import { SquadDetailPage } from './pages/SquadDetailPage';
import { SessionsPage } from './pages/SessionsPage';
import CalendarPage from './pages/CalendarPage';
import NewsPage from './pages/NewsPage';
import NewsDetailPage from './pages/NewsDetailPage';
import NewsFormPage from './pages/NewsFormPage';
import SessionPlansPage from './pages/SessionPlansPage';
import { AdminPage } from './pages/AdminPage';
import { NotificationCenterPage } from './pages/NotificationCenterPage';
import { CompetitionsPage } from './pages/CompetitionsPage';
import { MainLayout } from './components/layout/MainLayout';
import { ProtectedRoute } from './components/layout/ProtectedRoute';
import { Typography, Container, Box } from '@mui/material';

// Placeholder components for not yet implemented pages
const PlaceholderPage = ({ title }: { title: string }) => (
  <Container>
    <Box sx={{ mt: 4, textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        This page is coming soon...
      </Typography>
    </Box>
  </Container>
);

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/forgot-password" element={<PlaceholderPage title="Forgot Password" />} />

      {/* Protected routes with layout */}
      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route
          path="/users"
          element={
            <ProtectedRoute requiredRoles={['ADMIN', 'HEAD_COACH']}>
              <UsersPage />
            </ProtectedRoute>
          }
        />
        <Route path="/squads" element={<SquadsPage />} />
        <Route path="/squads/:id" element={<SquadDetailPage />} />
        <Route path="/sessions" element={<SessionsPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route
          path="/news/create"
          element={
            <ProtectedRoute requiredRoles={['ADMIN', 'HEAD_COACH']}>
              <NewsFormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/news/:id/edit"
          element={
            <ProtectedRoute requiredRoles={['ADMIN', 'HEAD_COACH']}>
              <NewsFormPage />
            </ProtectedRoute>
          }
        />
        <Route path="/news/:id" element={<NewsDetailPage />} />
        <Route path="/session-plans" element={<SessionPlansPage />} />
        <Route path="/competitions" element={<CompetitionsPage />} />
        <Route path="/knowledge" element={<PlaceholderPage title="Knowledge Center" />} />
        <Route path="/snc" element={<PlaceholderPage title="S&C Module" />} />
        <Route
          path="/notifications/center"
          element={
            <ProtectedRoute requiredRoles={['ADMIN', 'HEAD_COACH', 'COACH']}>
              <NotificationCenterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requiredRoles={['ADMIN']}>
              <AdminPage />
            </ProtectedRoute>
          }
        />
      </Route>

      {/* Redirects */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
